export default {
    version: "269",
    buildNumber: "320",
    baseUrl: "https://cf-st.sc-cdn.net/d/Bq046tEVkf0PmkWcl9nHj?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
